import React, {useContext, useState} from "react";

import envLangUa from '../ua.json'
import envLangEn from '../en.json'

export const LangContext = React.createContext(null)

/**
 * Pick one language out of a backend multilang string: "[:uk]Текст[:en]Text[:]".
 * Plain strings and non-strings are returned as is.
 * Falls back to uk, then to the first non-empty translation.
 */
export function translate(value, langCode) {
    if (typeof value !== 'string' || !value.includes('[:')) return value
    const parts = {}
    const re = /\[:([a-z]{2})\]([\s\S]*?)(?=\[:[a-z]{0,2}\]|$)/g
    let match
    while ((match = re.exec(value))) parts[match[1]] = match[2]
    const code = langCode === 'ua' ? 'uk' : langCode
    return parts[code] || parts.uk || Object.values(parts).find(Boolean) || ''
}

export const useLang = () => {
    const context = useContext(LangContext)
    if (!context) throw new Error("useLang must be used inside LangContext")
    return context
}

const LangProvider = ({children}) => {
    const [lang, setLang] = useState(null)

    console.log('lang init ',lang)

    if (!lang) updateLang(localStorage.getItem('lang') || 'ua')

    function updateLang(newlang){
      console.log("newlang",newlang)
      if ( !newlang ) return null
      if (newlang === "ua") {
        console.log("newlang is ua",newlang)
        localStorage.setItem('lang','ua')
        setLang(envLangUa)
      } else {
        localStorage.setItem('lang','en')
        console.log("newlang is en",newlang)
        setLang(envLangEn)
      }
    }
    /**
     * TODO: lang switch here
     */
    return <LangContext.Provider children={children} value={{lang, updateLang, t: value => translate(value, lang?.lang)}}/>
}
export default LangProvider
